import { observer } from 'mobx-react-lite';

import Locations from '../../Locations/Locations';
import {
  CartSiteAddress,
  useCartContext,
} from 'screens/AccessExpressV3/CartProvider';
import axios from 'axios';
import { updateOrder } from 'api/accessexpressv3/api';
import { buildItemPayload } from 'screens/AccessExpressV3/utils';

let cancelTokenSource = axios.CancelToken.source();
const LocationOrderBody = observer(() => {
  const cart = useCartContext();

  const handleLocationsChange = async (locations: Array<CartSiteAddress>) => {
    cart.setLocations(locations);
    if (cancelTokenSource) {
      cancelTokenSource?.cancel('Operation canceled due to new request.');
    }
    cancelTokenSource = axios.CancelToken.source();

    if (cart.draftId) {
      cart.setLoadingDraftQuote(true);
      const dataForPostOrUpdate = {
        additional_details: cart.additionalDetails ?? {},
        locations: cart.locations.map((location) => {
          return {
            address: {
              ...location,
              id: location.id as string,
            },
            order_items: cart
              .itemsByLocation(location.id)
              .map(buildItemPayload),
          };
        }),
      };
      updateOrder(dataForPostOrUpdate, cart.draftId, {
        cancelToken: cancelTokenSource.token,
      })
        .then((draft) => {
          cart.updateStateFromDraft(draft);
          cart.setLoadingDraftQuote(false);
        })
        .catch((error) => {
          cart.setLoadingDraftQuote(false);
          if (axios?.isAxiosError(error) && error?.name === 'CanceledError')
            return;
          console.log('Error updating draft:', error);
        });
    }
  };

  return (
    <Locations locations={cart.locations} onChange={handleLocationsChange} />
  );
});

export default LocationOrderBody;
